import { render, staticRenderFns } from "./LvPopupUploadGuidelineArticle.vue?vue&type=template&id=2bd9e8c7"
import script from "./LvPopupUploadGuidelineArticle.vue?vue&type=script&lang=js"
export * from "./LvPopupUploadGuidelineArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports